<a class="offscreen" href="#content">{{ "ZurückZumInhalt" | translate }}</a>
<ngx-loading-bar [includeSpinner]="false" color="#A8B30A" height="0.2rem"></ngx-loading-bar>
@if (deploymentMode === "PUBLIC") {
  <div>
    <cap-intercapi-public-layout></cap-intercapi-public-layout>
  </div>
}
@if (deploymentMode === "READ") {
  <div>
    <cap-intercapi-layout></cap-intercapi-layout>
  </div>
}
@if (deploymentMode === "WRITE") {
  <div>
    <h1>Intercapi writeable mode not yet implemented</h1>
  </div>
}
